import { render, staticRenderFns } from "./ModifiersButtons.vue?vue&type=template&id=e2603980&"
import script from "./ModifiersButtons.vue?vue&type=script&lang=js&"
export * from "./ModifiersButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports